import { openDB } from 'idb'

export const initDB = async (dbName, keyName) => {
    return openDB(dbName, 1,{
        upgrade(db){
            if (!db.objectStoreNames.contains(keyName)) {
                db.createObjectStore(keyName, { keyPath: 'id', autoIncrement: true})
            }
        }
    })
}

export const insertData = async (dbName, keyName, data) => {
    const db = await initDB(dbName, keyName);
    await db.add(keyName, data)
}

export const getAllData = async (dbName, keyName) => {
    const db = await initDB(dbName, keyName);
    return db.getAll(keyName)
}

export const deleteIndexedDB = (dbName) => {
	return new Promise((resolve, reject) => {
		const deleteRequest = indexedDB.deleteDatabase(dbName);

		deleteRequest.onsuccess = () => {
			console.log(`✅ Database "${dbName}" deleted successfully.`);
			resolve(true);
		};

		deleteRequest.onerror = (event) => {
			console.error(`❌ Failed to delete database "${dbName}"`, event);
			reject(event);
		};

		deleteRequest.onblocked = () => {
			console.warn(`⚠️ Deletion of "${dbName}" is blocked. Close other tabs using the DB.`);
		};
	});
};